
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Προσθέστε το στην Οθόνη Αφετηρίας για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
's224cbcec014ef6b5': `Πατήστε "Κοινή χρήση" στη γραμμή πλοήγησης`,
's37a9e8aec5713460': `Περισσότερα`,
's386eca8362ff6155': `Πατήστε Περισσότερα αν δεν υπάρχει εικονίδιο Κοινοποίησης`,
's4e1e10a6ca408245': `Πατήστε "Προσθήκη στην οθόνη Αφετηρίας"`,
's6196153c4b0c1ea0': `Εγκατάσταση`,
's633502f7cff4f847': `Ανοίξτε το μενού του περιηγητή σας`,
's681e399d63311fba': `Εμφάνιση συλλογής`,
's7f0591f08e318eda': `Πατήστε Περισσότερα στο μενού Κοινοποίησης`,
's8114bd55cae5a22b': `Πατήστε "Προσθήκη στο Dock"`,
's922329d6f6213590': `Προσθήκη στο Dock`,
's9af56bf005b49c74': `Κάντε κύλιση προς τα κάτω στο "Προσθήκη στην οθόνη Αφετηρίας"`,
'sa5ef80b4bb9b39f8': `Λιγότερα`,
'sba52286c21552a4e': `Εγκαταστήστε το στη συσκευή σας για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
'sc16e00a7a8b2fde2': `Πίσω`,
'scdaf4bbff76674c8': `Προσθήκη στην οθόνη Αφετηρίας`,
'se0e473adfda8066c': `Ανοίξτε στον κύριο περιηγητή σας`,
'se740f75b95a51807': `Προσθέστε το στο Dock για εκτεταμένη εμπειρία και εύκολη πρόσβαση.`,
'sfea652f6580ff086': `Αυτός ο ιστότοπος έχει λειτουργικότητα εφαρμογής.`,
    };
  